import { MultiValuedListMoreItem } from '../../../MultiValuedList'
import { RequestPhaseAsyncMultiValue } from '../RequestPhaseAsyncMultiValue'

import * as styles from './RequestPhaseAsyncMultiValuedListMoreItem.module.css'

function RequestPhaseAsyncMultiValuedListMoreItem({
  className = styles.RequestPhaseAsyncMultiValuedListMoreItem,
  name,
  progress,
}) {
  return (
    <MultiValuedListMoreItem className={className}>
      <RequestPhaseAsyncMultiValue name={name} progress={progress} />
    </MultiValuedListMoreItem>
  )
}

export default RequestPhaseAsyncMultiValuedListMoreItem
